import { Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

export default function GenericError() {
  const { t } = useTranslation('translation', { keyPrefix: 'components.genericError' });

  return (
    <Container
      maxWidth='md'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
      }}
    >
      <img width={70} height={70} src='/images/circleX.svg' alt='error' />
      <Typography variant='h1'>{t('title')}</Typography>
      <Typography align='center'>{t('subtitle')}</Typography>
      <Stack direction='row' width='100%' justifyContent='space-evenly' gap={2}>
        <NavLink to='/batch'>
          <Typography align='center'>{t('batchLink')}</Typography>
        </NavLink>
        <NavLink to='/'>
          <Typography align='center'>{t('homeLink')}</Typography>
        </NavLink>
        <NavLink to='/products'>
          <Typography align='center'>{t('skuLink')}</Typography>
        </NavLink>
      </Stack>
    </Container>
  );
}
